import React, {createContext, useEffect, useReducer, useContext} from 'react';
import {getVenueSummary} from '../../api';
import moment from 'moment';

const ReportContext = createContext();

const initialState = {
  query: {
    type: 'monthly',
    year: 0,
    month: 0,
  },
  data: null,
  fetched_query: null,
};

function reducer(state, action) {
  console.log(state, action);
  switch (action.type) {
    case 'init': {
      return {
        ...state,
        query: {
          ...state.query,
          ...action.query,
        },
        data: null,
      };
    }
    case 'set_summary_data': {
      const newState = {
        ...state,
        data: action.data,
        fetched_query: action.query,
      };
      if (
          newState.data &&
          newState.data.offline_rooms &&
          newState.data.offline_rooms.items &&
          newState.data.offline_rooms.items.length
      ) {
        newState.data.offline_rooms.items.reverse();

        let now = Date.now();
        let day = 1000 * 3600 * 24;
        let year = day * 365;
        newState.data.offline_rooms.items.forEach((item) => {
          let m = moment(item.value);
          item.text = m.format('YYYY/MM/DD');
          let t = m.toDate().getTime();
          /*let d = now - t;
          if (d >= year * 3) {
            item.text = 'More than 3 years';
          } else if (d >= year * 2) {
            item.text = 'More than 2 years';
          } else if (d >= year) {
            item.text = 'More than 1 year+';
          } else if (d >= day * 180) {
            item.text = 'More than 180 days';
           */
          if (t < 1) {
            item.text = `Never`;
          } else {
            item.text = m.format('YYYY/MM/DD');
          }
        });
      }
      return newState;
    }
    default:
      throw new Error(`${action.type} is not defined.`);
  }
}

export const ReportContextProvider = ({api, children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  let doQuery = async (query) => {
    if (
        state.fetched_query &&
        state.data &&
        state.fetched_query.year == state.year &&
        state.fetched_query.month == state.month
    ) {
      return;
    }

    dispatch({
      type: 'init',
      query,
    });

    try {
      const data = await getVenueSummary(query);

      if (data?.room_graphs) {
        if (data.room_graphs.hours) {
          data.room_graphs.rooms = data.room_graphs.hours.map(r => {
            switch (r.type) {
              default:
              case 'total':
                return {
                  type: 'total',
                  name: 'Total',
                  detail_name: 'Total',
                  id: 0,
                };
              case 'room':
                return {
                  type: 'room',
                  name: r.room.name,
                  room: r.room,
                  detail_name: r.room.name,
                  id: r.id,
                };
              case 'device':
                return {
                  type: 'device',
                  name: r.device.floor_name || `${r.device.customer_id}`,
                  detail_name: `${r.device.name ||
                  'NO NAME'} (${r.device.customer_id}) / ${r.device.device_name}`,
                  device: r.device,
                  id: r.id,
                };
            }
          });
        }
      }

      dispatch({
        type: 'set_summary_data',
        data,
        query,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const value = {state, dispatch, doQuery};

  return (
      <ReportContext.Provider value={value}>
        {children}
      </ReportContext.Provider>
  );
};

export const useReport = () => {
  return useContext(ReportContext);
};

export default ReportContext;
